import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import StyledSystemPropTypes from '@styled-system/prop-types';

import { Box } from '../grid';
import { Image } from '../image';
import { Label } from '../typography/new';
import { cmsImagePropTypes } from '../../prop-types';
import { breakpoints } from '../../constants';
import { ConditionalLink } from '../card/conditional-link';

const CategoryCardWrapper = styled(Box)`
  aspect-ratio: 1;
  background-color: ${({ theme }) => theme.colors.grey70};
  border-radius: 24px;
  overflow: hidden;
  position: relative;
  color: white;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  padding: 16px;

  @media (min-width: ${breakpoints.lg}) {
    padding: 32px;
  }

  &::before {
    background: rgba(0, 0, 0, 0.4);
    content: '';
    inset: 0;
    position: absolute;
    z-index: 1;
  }
`;

const CategoryCard = ({ title, image, href, transform }) => {
  return (
    <Box transform={transform}>
      <ConditionalLink href={href}>
        <CategoryCardWrapper>
          {image?.url && (
            <Image
              src={image.url}
              alt={image.alt || title}
              position="absolute"
              top="0"
              left="0"
              width="100%"
              height="100%"
              objectFit="cover"
            />
          )}
          <Label variant="category" my="0" zIndex={2} textTransform="none">
            {title}
          </Label>
        </CategoryCardWrapper>
      </ConditionalLink>
    </Box>
  );
};

CategoryCard.propTypes = {
  ...StyledSystemPropTypes.space,
  ...StyledSystemPropTypes.layout,
  title: PropTypes.string.isRequired,
  image: cmsImagePropTypes,
  href: PropTypes.string,
};

CategoryCard.defaultProps = {
  image: null,
  href: undefined,
};

export { CategoryCard };
